export const COMPANY = {
  name: "DNA Automotive GmbH",
  legalName: "DNA Automotive GmbH / MotorWorld Köln-Rheinland",
  tagline: "Dein neues Auto",
  addressLine: "Butzweilerstraße 35-39",
  city: "50829 Köln",
  location: "MotorWorld Köln-Rheinland",
  managingDirector: "Tim Tiedemann",
  phone: "+49 221 290 447 44",
  phoneHref: "+4922129044744",
  whatsapp: "491771693925",
  email: "info@dna-automotive.de",
  hrb: "HRB 126459",
  court: "Amtsgericht Köln",
  taxNumber: "5217/5723/3090",
  vatId: "DE460957839",
  hours: [
    { day: "Mo – Fr", time: "10:00 – 18:00 Uhr" },
    { day: "Samstag", time: "Nach Absprache" },
    { day: "Sonntag", time: "Geschlossen" },
  ],
};

export const translations = {
  de: {
    nav: { vehicles: "Fahrzeuge", abo: "Auto-Abo", rental: "Mietwagen", financing: "Finanzierung", ankaufInzahlung: "Ankauf / Inzahlungnahme", services: "Leistungen", sold: "Verkaufte Fahrzeuge", service: "Service", about: "Über uns", contact: "Kontakt", career: "Karriere", ankauf: "Ankauf", inzahlung: "Inzahlungnahme", partners: "Partner", admin: "Admin" },
    hero: {
      overline: "Ankauf · Verkauf · Inzahlungnahme · Premium Service",
      line1: "Exklusive",
      line2: "Fahrzeuge",
      line3: "in Köln",
      subtitle: "Wir finden Ihren Traumwagen. Premium-Fahrzeuge, transparenter Service und ein Standort, der Maßstäbe setzt.",
      cta1: "Traumwagen finden",
      cta2: "Kontakt aufnehmen",
    },
    marqueeWord: "DEIN NEUES AUTO",
    abo: {
      overline: "Flexibel fahren",
      title: "Auto-Abo & Vermietung",
      subtitle: "Maximale Flexibilität ohne langfristige Bindung – ein Preis, alles inklusive. Ob für einen Tag oder mehrere Monate.",
      ctaConsult: "Jetzt beraten lassen",
      ctaExplore: "Fahrzeuge entdecken",
      glanceTitle: "DNA Auto-Abo auf einen Blick",
      glanceSubtitle: "Alles, was Ihr Business bewegt – transparent und flexibel.",
      glance: [
        { t: "Ø 10 Werktage", d: "Schnelle Lieferzeit" },
        { t: "6 Monate", d: "Flexible Laufzeit" },
        { t: "Ein Preis", d: "Alles inklusive" },
        { t: "3.500 km", d: "pro Monat inklusive" },
        { t: "∞ Zusatzfahrer", d: "ohne Aufpreis" },
        { t: "0 € Anzahlung", d: "liquiditätsschonend" },
        { t: "24/7", d: "Persönlicher Ansprechpartner" },
        { t: "100 % digital", d: "Von Anfrage bis Rückgabe" },
      ],
      advantagesTitle: "Ihre Vorteile mit DNA",
      advantages: [
        { t: "Wunschfahrzeug mit Premium-Ausstattung", d: "Sie bekommen genau das Fahrzeug, das Sie wählen – keine Überraschungen, immer hochwertig ausgestattet." },
        { t: "Klare Kosten, volle Planungssicherheit", d: "Nur die monatliche Abo-Rate – keine Anzahlung, keine Schlussrate, keine versteckten Zusatzkosten." },
        { t: "Mobilitätsgarantie", d: "Ob Panne, Unfall oder Ausfall – wir sorgen umgehend für Ersatz, damit Sie mobil bleiben." },
      ],
      stepsTitle: "So funktioniert's",
      stepsSubtitle: "In vier einfachen Schritten zu Ihrem Wunschfahrzeug.",
      steps: [
        { t: "Bedarf klären", d: "Gemeinsam mit unseren Experten finden wir das passende Fahrzeug und die richtige Konfiguration für Sie." },
        { t: "Wunschauto aussuchen & Angebot erhalten", d: "Wählen Sie aus einer großen Auswahl an Premium-Marken. Ihr Angebot passt exakt zu Ihren Anforderungen." },
        { t: "Vertrag bestätigen", d: "Unterzeichnen Sie Ihren Vertrag bequem und vollständig digital – transparent begleitet." },
        { t: "Losfahren", d: "Wir stimmen Lieferdatum und -ort mit Ihnen ab. Innerhalb weniger Tage, deutschlandweit." },
      ],
      brandsTitle: "Premium-Marken im Abo",
      testimonialsTitle: "Zufriedene DNA-Kunden",
      testimonials: [
        { name: "Matthias S.", text: "Top Qualität, reibungslose Abwicklung und erstklassiger Service. Verlässlichkeit, wie man sie heute nur selten findet – absolut empfehlenswert!" },
        { name: "Detlef B.", text: "Abwicklung und Anlieferung haben super geklappt. Sehr kompetente und freundliche Mitarbeiter. Ein komplett ausgestattetes Fahrzeug zum Top Preis-Leistungsverhältnis." },
        { name: "Oliver B.", text: "Tolle, schnelle sowie professionelle Abwicklung. DNA sticht eindeutig unter den Anbietern hervor." },
        { name: "Maxim G.", text: "Beste Firma für die Auto-Langmiete. Die Autos sind top ausgestattet, Service top, Management top! Wir sind sehr zufrieden!" },
      ],
      faqTitle: "Häufig gestellte Fragen",
      faq: [
        { q: "Was passiert nach der Laufzeit?", a: "Nach Ablauf haben Sie die Wahl: Entweder Sie verlängern Ihr Abo mit einem neuen Fahrzeug, oder der Vertrag endet automatisch und wir holen das Fahrzeug bei Ihnen ab – unkompliziert." },
        { q: "Kann ich mehrere Fahrzeuge abonnieren?", a: "Ja, Sie können problemlos mehrere Fahrzeuge gleichzeitig buchen – ob für einzelne Mitarbeiter, ganze Teams oder als flexible Flotte." },
        { q: "Welche Fahrzeuge bietet DNA an?", a: "Vom kompakten Stadtwagen bis zur Oberklasse-Limousine bieten wir Fahrzeuge für jeden Bedarf – mit Premium-Ausstattung." },
        { q: "Wer ist mein Ansprechpartner?", a: "Bei DNA haben Sie einen festen persönlichen Ansprechpartner, der Sie von der Auslieferung bis zur Rückgabe begleitet." },
        { q: "Was unterscheidet das Abo vom Leasing?", a: "Keine Anzahlung, keine Schlussrate und keine langen Bindungen. Eine monatliche Rate deckt alle wichtigen Leistungen ab – volle Planungssicherheit." },
        { q: "Was passiert bei Schaden oder Panne?", a: "Sie erreichen uns jederzeit. Dank Mobilitätsgarantie stellen wir schnellstmöglich Ersatz bereit, damit Sie mobil bleiben." },
      ],
      listing: {
        overline: "Exklusive Auto Abos bei DNA Automotive",
        title: "Ihr Traumfahrzeug. Eine monatliche Rate. Maximale Freiheit.",
        text: "Erleben Sie automobile Vielfalt auf höchstem Niveau. Mit den exklusiven Auto Abo Angeboten der DNA Automotive GmbH genießen Sie erstklassige Fahrzeuge zu attraktiven monatlichen Konditionen. Ob sportlicher MINI John Cooper Works, komfortable Mercedes-Benz Limousine, exklusiver BMW oder luxuriöser Range Rover: Entdecken Sie unsere sofort verfügbaren Fahrzeuge und finden Sie das passende Auto Abo für Ihre individuellen Ansprüche.",
        text2: "Unsere Angebote überzeugen mit transparent dargestellten monatlichen Bruttoraten und großzügigen Freikilometern von bis zu 3.500 Kilometern monatlich. Jetzt Wunschfahrzeug entdecken, Auto Abo anfragen und persönlich beraten lassen.",
        allBrands: "Alle Marken",
        allPrices: "Alle Raten",
        priceLow: "bis 1.000 €",
        priceMid: "1.000 – 2.000 €",
        priceHigh: "über 2.000 €",
        badge: "Sofort verfügbar",
        badgeSub: "Auto Abo sofort möglich",
        perMonth: "brutto / Monat",
        freeKm: "Freikilometer monatlich",
        cta: "Jetzt Auto Abo anfragen",
        count: "sofort verfügbare Fahrzeuge",
        empty: "Keine Fahrzeuge für diese Auswahl – bitte Filter anpassen.",
        examplePhoto: "Beispielfoto",
      },
      benefitsBar: [
        { t: "0 €", d: "Anzahlung" },
        { t: "6 Mon.", d: "Laufzeit" },
        { t: "3.500 km", d: "pro Monat inkl." },
        { t: "∞", d: "Zusatzfahrer" },
        { t: "All-in", d: "Versicherung · Steuer · Wartung" },
      ],
      subscription: {
        tag: "Auto-Abo",
        title: "Fahren im Abo",
        desc: "Ihr Wunschfahrzeug im monatlichen Abo. Versicherung, Steuer, Wartung und Zulassung inklusive – einfach einsteigen und losfahren.",
        features: ["Feste monatliche Rate, alles inklusive", "Laufzeit flexibel wählbar", "Keine Anzahlung nötig", "Versicherung, Steuer & Wartung inklusive"],
        cta: "Abo anfragen",
      },
      rental: {
        tag: "Vermietung",
        title: "Premium-Vermietung",
        desc: "Sie brauchen ein Fahrzeug nur kurzzeitig? Mieten Sie exklusive Fahrzeuge tage- oder wochenweise – ideal für besondere Anlässe.",
        features: ["Tages-, Wochen- & Monatsmiete", "Exklusive Fahrzeugauswahl", "Faire, transparente Preise", "Schnelle & unkomplizierte Abwicklung"],
        cta: "Mietanfrage senden",
      },
    },
    finance: {
      overline: "Passende Finanzierung",
      title: "Finanzierung",
      subtitle: "Ihr Traumwagen – passend finanziert. Fair, transparent und sicher, gemeinsam mit unseren starken Partnern.",
      benefits: [
        { t: "Ab 4,90 %", d: "Attraktive Zinsen für Ihre Wunschfinanzierung." },
        { t: "Ohne Anzahlung", d: "Finanzierung auch ganz ohne Anzahlung möglich." },
        { t: "Bis 120 Monate", d: "Flexible Laufzeiten – passend zu Ihrem Budget." },
        { t: "Schnelle Zusage", d: "Unkomplizierte Abwicklung direkt bei uns im Haus." },
      ],
      calc: { title: "Finanzierungsrechner", amount: "Fahrzeugpreis", down: "Anzahlung", term: "Laufzeit", months: "Monate", monthly: "Monatliche Rate ca.", rate: "Zinssatz", disclaimer: "Unverbindliche Beispielrechnung. Bonität vorausgesetzt. Kein verbindliches Angebot." },
      partnersTitle: "Unsere Finanzierungspartner",
      cta: "Finanzierung anfragen",
    },
    ankauf: {
      overline: "Fahrzeug verkaufen",
      title: "Fahrzeug-Ankauf",
      subtitle: "Verkaufen Sie Ihr Fahrzeug schnell, fair und unkompliziert an DNA Automotive. Angaben ausfüllen, Bilder hochladen – wir melden uns mit einem Angebot.",
      steps: [
        { t: "Daten angeben", d: "Fahrzeug- und Kontaktdaten eintragen." },
        { t: "Bilder hochladen", d: "Fotos Ihres Fahrzeugs hinzufügen." },
        { t: "Angebot erhalten", d: "Wir melden uns mit einem fairen Angebot." },
      ],
      form: {
        yourData: "Ihre Daten", vehicleData: "Fahrzeugdaten",
        name: "Name", email: "E-Mail", phone: "Telefon",
        brand: "Marke", model: "Modellbezeichnung", year: "Erstzulassung (z. B. 05/2019)",
        mileage: "Kilometerstand", fuel: "Kraftstoff", transmission: "Getriebe",
        condition: "Zustand", price: "Preisvorstellung (€)", message: "Nachricht (optional)",
        images: "Fahrzeugbilder hochladen", uploadHint: "JPG/PNG · bis zu 12 MB pro Bild",
        submit: "Ankauf-Anfrage senden", sending: "Wird gesendet...",
        success: "Vielen Dank! Ihre Ankauf-Anfrage wurde gesendet.", error: "Senden fehlgeschlagen. Bitte erneut versuchen.",
        uploading: "Bild wird hochgeladen...",
      },
    },
    inzahlung: {
      overline: "Inzahlungnahme",
      title: "Inzahlungnahme",
      subtitle: "Geben Sie Ihr aktuelles Fahrzeug bei uns in Zahlung und rechnen Sie den Wert direkt auf Ihr neues Wunschfahrzeug an – fair bewertet und unkompliziert.",
      desiredLabel: "Wunschfahrzeug (optional)",
      desiredPlaceholder: "z. B. BMW X5, Porsche Cayenne ...",
      steps: [
        { t: "Fahrzeug angeben", d: "Daten Ihres aktuellen Fahrzeugs eintragen." },
        { t: "Wunschauto wählen", d: "Sagen Sie uns, welches Fahrzeug Sie interessiert." },
        { t: "Anrechnung erhalten", d: "Wir bewerten fair und rechnen direkt an." },
      ],
    },
    about: {
      overline: "Über uns",
      title: "Willkommen bei DNA Automotive",
      text: "Mitten in der legendären MotorWorld Köln zuhause, ist DNA Automotive weit mehr als ein Autohaus – wir sind eine Adresse für Menschen, die Fahrzeuge lieben. In einem der spektakulärsten Automobil-Erlebniszentren Europas präsentieren wir exklusive Fahrzeuge in einem Ambiente, das Emotionen weckt und Autoträume greifbar macht.",
      text2: "Unsere Leidenschaft ist Ihr Vorteil: Ankauf, Verkauf, Inzahlungnahme, Premium-Service, Finanzierung, Leasing und Auto-Abo – alles aus einer Hand. Wir beraten ehrlich, handeln transparent und begegnen Ihnen immer auf Augenhöhe. Für Ihr neues Auto – oder genau das Fahrzeug, von dem Sie schon lange träumen.",
      quote: "Wir verkaufen keine Autos. Wir liefern das Gefühl, das dein nächstes Fahrzeug auslöst.",
      founderName: "Tim Tiedemann",
      founderRole: "Geschäftsführer & Gründer",
      locationCaption: "Unser Showroom · MotorWorld Köln-Rheinland",
      stats: [
        { value: "20+", label: "Fahrzeuge im Bestand" },
        { value: "8", label: "Premium-Marken" },
        { value: "100%", label: "Geprüfte Qualität" },
        { value: "4,90%", label: "Finanzierung ab" },
      ],
    },
    fuhrpark: {
      overline: "Aktueller Fuhrpark",
      title: "Unsere Fahrzeuge",
      subtitle: "Handverlesene Premium-Fahrzeuge. Unser Bestand wechselt laufend – sichern Sie sich Ihr Wunschfahrzeug.",
      all: "Alle Fahrzeuge ansehen",
      empty: "Aktuell keine Fahrzeuge verfügbar. Sprechen Sie uns an – wir finden Ihr Wunschfahrzeug.",
      sold: "Verkauft",
      inquire: "Fahrzeug anfragen",
      details: "Details",
    },
    specs: { year: "Baujahr", mileage: "Kilometerstand", power: "Leistung", fuel: "Kraftstoff", transmission: "Getriebe", body: "Karosserie" },
    services: {
      overline: "Was wir tun",
      title: "Unsere Leistungen",
      intro: "Mehr als ein Autohaus. Wir verstehen uns als langfristiger Partner für exklusive Mobilität – nachhaltige Kundenbeziehungen, basierend auf Vertrauen, Qualität und persönlichem Service.",
      items: [
        { n: "01", t: "Fahrzeugankauf", d: "Wir kaufen Ihr Fahrzeug zu fairen Konditionen an – schnell, transparent und unkompliziert." },
        { n: "02", t: "Fahrzeugverkauf", d: "Exklusive Fahrzeuge, geprüft und in Top-Zustand. Für Kenner und Liebhaber." },
        { n: "03", t: "Finanzierung", d: "Individuelle Finanzierung ab 4,90 % – auch ohne Anzahlung, mit Santander & Bank11." },
        { n: "04", t: "Leasing", d: "Flexible Leasing-Lösungen für Privat- und Geschäftskunden." },
        { n: "05", t: "Auto-Abo", d: "Fahren ohne langfristige Bindung – ein Preis, alles inklusive, jederzeit kündbar." },
        { n: "06", t: "Mietwagen", d: "Premium-Mietfahrzeuge für Tage oder Wochen – ideal für Events, Reisen oder Testfahrten." },
        { n: "07", t: "Inzahlungnahme", d: "Altfahrzeug in Zahlung geben und direkt beim Neukauf anrechnen lassen." },
        { n: "08", t: "Fahrzeuganlieferung", d: "Wir liefern Ihr Fahrzeug persönlich – deutschlandweit, auf Wunsch europaweit." },
        { n: "09", t: "Abholservice", d: "Wir holen Ihr Fahrzeug bei Ihnen ab – für Ankauf, Service oder Inzahlungnahme." },
        { n: "10", t: "Zulassungsservice", d: "Kennzeichen, Zulassung, Ummeldung – wir übernehmen den kompletten Papierkram." },
        { n: "11", t: "Fahrzeugaufbereitung", d: "Professionelles Detailing: Innen, Außen, Politur, Lackversiegelung, Lederpflege." },
        { n: "12", t: "Fahrzeugbeschriftung", d: "Werbebeschriftung, Firmenlogos und individuelle Designs in Premium-Qualität." },
        { n: "13", t: "Folierung", d: "Farbwechsel-, Chrome-Delete- und Steinschlagschutz-Folierungen durch zertifizierte Partner." },
        { n: "14", t: "Fuhrparkservice", d: "Komplettbetreuung für Firmenfuhrparks: Beschaffung, Betreuung, Rückgabe – alles aus einer Hand." },
        { n: "15", t: "Individuelle Fahrzeugbeschaffung", d: "Ihr präzises Wunschfahrzeug – wir finden es diskret aus unserem internationalen Netzwerk." },
      ],
      komplettOverline: "Komplettpaket",
      komplettTitle: "Warum DNA Automotive",
      komplettItems: [
        { t: "Individuelle Beratung", d: "Jeder Kunde ist einzigartig – wir hören zu und liefern maßgeschneiderte Lösungen." },
        { t: "Expertise in der KFZ-Branche", d: "Jahrelange Erfahrung mit Premium- und High-Performance-Fahrzeugen." },
        { t: "Hervorragende Erreichbarkeit", d: "Kurze Wege, klare Ansprache, verlässliche Rückmeldung – 24/7 auf WhatsApp." },
        { t: "Service auch nach dem Auftrag", d: "Wir sind auch nach dem Kauf für Sie da – transparente Betreuung, ehrliche Antworten." },
        { t: "Enge Zusammenarbeit", d: "Nationales & internationales Partnernetzwerk für Fahrzeuge, die selten öffentlich verfügbar sind." },
      ],
      exklOverline: "Exklusivität statt Masse",
      exklTitle: "Qualität als Versprechen",
      exklText: "Unser Portfolio umfasst ausschließlich sorgfältig ausgewählte Premium- und High-Performance-Fahrzeuge. Qualität, Historie und Werthaltigkeit stehen dabei konsequent im Mittelpunkt.",
      exklPillars: [
        { t: "Persönliche Beratung", d: "Individuelle Fahrzeuglösungen, perfekt abgestimmt auf Ihre Wünsche und Anforderungen." },
        { t: "Diskretion als Standard", d: "Absolute Verlässlichkeit, vertrauliche Kommunikation und professionelle Abwicklung." },
        { t: "Ein starkes Netzwerk", d: "Zugang zu außergewöhnlichen Fahrzeugen, die häufig nicht öffentlich verfügbar sind." },
      ],
    },
    partners: { overline: "Vertrauen & Finanzierung", title: "Unsere Partner", subtitle: "Starke Partner für sichere Finanzierung und faire Konditionen." },
    contact: {
      overline: "Sprechen Sie mit uns",
      title: "Kontakt",
      subtitle: "Sie haben Fragen oder Interesse an einem Fahrzeug? Wir freuen uns auf Ihre Nachricht.",
      name: "Name", email: "E-Mail", phone: "Telefon", subject: "Betreff", message: "Nachricht",
      send: "Nachricht senden", sending: "Wird gesendet...",
      success: "Vielen Dank! Ihre Anfrage wurde gesendet.",
      error: "Senden fehlgeschlagen. Bitte versuchen Sie es erneut.",
      call: "Anrufen", write: "E-Mail schreiben",
      openingLabel: "Öffnungszeiten",
      route: "Route planen",
      whatsapp: "Per WhatsApp schreiben",
      web: "Webseite",
    },
    deal: {
      overline: "Angebot des Tages",
      cta: "Fahrzeug entdecken",
      whatsapp: "Per WhatsApp anfragen",
      financing: "Finanzierung ab",
      perMonth: "/ Monat",
    },
    locationStrip: {
      overline: "Unser Standort",
      title: "Mitten in der MotorWorld Köln-Rheinland",
      text: "Erleben Sie unsere Fahrzeuge in einer der spektakulärsten Automobil-Locations Europas – umgeben von klassischen Sportwagen, moderner Architektur und echter Automobil-Kultur.",
      cta: "Standort entdecken",
    },
    servicesHome: {
      all: "Alle 15 Leistungen entdecken",
      more: "Mehr erfahren",
      categories: [
        { n: "01", t: "Verkauf & Ankauf", d: "Fahrzeugverkauf, Ankauf und Inzahlungnahme zu fairen, transparenten Konditionen." },
        { n: "02", t: "Finanzierung & Leasing", d: "Individuelle Finanzierung ab 4,90 % und flexible Leasinglösungen mit Santander & Bank11." },
        { n: "03", t: "Auto-Abo & Mietwagen", d: "Flexibel fahren ohne lange Bindung – Auto-Abo oder Premium-Mietwagen." },
        { n: "04", t: "Premium Rundum-Service", d: "Aufbereitung, Folierung, Beschriftung, Zulassung, Anlieferung, Fuhrpark und Beschaffung." },
      ],
    },
    footer: { rights: "Alle Rechte vorbehalten.", imprint: "Impressum", privacy: "Datenschutz", nav: "Navigation", cookies: "Cookie-Einstellungen" },
    cookie: {
      title: "Cookies & Datenschutz",
      text: "Wir nutzen technisch notwendige Cookies, damit diese Website funktioniert. Mit Ihrer Einwilligung setzen wir zusätzlich Statistik-Cookies (PostHog) ein, um die Nutzung unserer Website zu verstehen und zu verbessern. Ohne Einwilligung findet kein Tracking statt. Ihre Auswahl können Sie jederzeit über die Cookie-Einstellungen im Footer ändern.",
      more: "Mehr in der Datenschutzerklärung",
      acceptAll: "Alle akzeptieren",
      essential: "Nur essenzielle",
    },
    detail: { back: "Zurück zum Fuhrpark", inquire: "Dieses Fahrzeug anfragen", whatsapp: "Per WhatsApp anfragen", description: "Beschreibung", price: "Preis" },
    admin: {
      login: "Anmelden", email: "E-Mail", password: "Passwort", loggingIn: "Anmeldung...",
      dashboard: "Fahrzeugverwaltung", newVehicle: "Neues Fahrzeug", edit: "Bearbeiten", delete: "Löschen",
      save: "Speichern", cancel: "Abbrechen", logout: "Abmelden",
      confirmDelete: "Fahrzeug wirklich löschen?", uploadImage: "Bilder hochladen",
      loginError: "Ungültige Zugangsdaten",
    },
  },
  en: {
    nav: { vehicles: "Vehicles", sold: "Sold Vehicles", services: "Services", service: "Service", about: "About", contact: "Contact", career: "Careers", abo: "Car Subscription", rental: "Car Rental", financing: "Financing", ankauf: "Sell your car", ankaufInzahlung: "Purchase / Trade-in", inzahlung: "Trade-in", partners: "Partners", admin: "Admin" },
    hero: {
      overline: "Purchase · Sales · Trade-in · Premium Service",
      line1: "Exclusive",
      line2: "Vehicles",
      line3: "in Cologne",
      subtitle: "We find your dream car. Premium vehicles, transparent brokerage and a service that sets the standard.",
      cta1: "Find your dream car",
      cta2: "Get in touch",
    },
    marqueeWord: "YOUR NEW CAR",
    abo: {
      overline: "Drive flexibly",
      title: "Car Subscription & Rental",
      subtitle: "Maximum flexibility without long-term commitment – one price, all included. Whether for a day or several months.",
      ctaConsult: "Get expert advice",
      ctaExplore: "Explore vehicles",
      glanceTitle: "DNA Car Subscription at a glance",
      glanceSubtitle: "Everything that keeps your business moving – transparent and flexible.",
      glance: [
        { t: "Ø 10 working days", d: "Fast delivery time" },
        { t: "6 months", d: "Flexible term" },
        { t: "One price", d: "All included" },
        { t: "3,500 km", d: "per month included" },
        { t: "∞ extra drivers", d: "at no extra cost" },
        { t: "€0 down payment", d: "protects your liquidity" },
        { t: "24/7", d: "Personal contact person" },
        { t: "100% digital", d: "From request to return" },
      ],
      advantagesTitle: "Your advantages with DNA",
      advantages: [
        { t: "Your chosen vehicle with premium equipment", d: "You get exactly the vehicle you choose – no surprises, always high-quality equipment." },
        { t: "Clear costs, full planning security", d: "Only the monthly subscription rate – no down payment, no final payment, no hidden extra costs." },
        { t: "Mobility guarantee", d: "Whether breakdown, accident or downtime – we arrange a replacement immediately so you stay mobile." },
      ],
      stepsTitle: "How it works",
      stepsSubtitle: "Four simple steps to your desired vehicle.",
      steps: [
        { t: "Clarify your needs", d: "Together with our experts we find the right vehicle and configuration for you." },
        { t: "Choose your car & receive an offer", d: "Choose from a wide range of premium brands. Your offer matches your requirements exactly." },
        { t: "Confirm the contract", d: "Sign your contract conveniently and fully digitally – transparently guided." },
        { t: "Drive off", d: "We arrange the delivery date and location with you. Within a few days, nationwide." },
      ],
      brandsTitle: "Premium brands on subscription",
      testimonialsTitle: "Happy DNA customers",
      testimonials: [
        { name: "Matthias S.", text: "Top quality, smooth handling and first-class service. Reliability you rarely find these days – absolutely recommended!" },
        { name: "Detlef B.", text: "Handling and delivery went great. Very competent and friendly staff. A fully equipped vehicle at top value for money." },
        { name: "Oliver B.", text: "Great, fast and professional handling. DNA clearly stands out among providers." },
        { name: "Maxim G.", text: "Best company for long-term car rental. The cars are top equipped, service top, management top! We are very satisfied!" },
      ],
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "What happens after the term?", a: "After it ends you have the choice: either extend your subscription with a new vehicle, or the contract ends automatically and we pick up the vehicle – hassle-free." },
        { q: "Can I subscribe to several vehicles?", a: "Yes, you can easily book several vehicles at once – for individual employees, entire teams or as a flexible fleet." },
        { q: "Which vehicles does DNA offer?", a: "From compact city cars to luxury sedans, we offer vehicles for every need – with premium equipment." },
        { q: "Who is my contact person?", a: "At DNA you have a dedicated personal contact who supports you from delivery to return." },
        { q: "How does the subscription differ from leasing?", a: "No down payment, no final payment and no long commitments. One monthly rate covers all key services – full planning security." },
        { q: "What happens in case of damage or breakdown?", a: "You can reach us anytime. Thanks to our mobility guarantee we provide a replacement as quickly as possible so you stay mobile." },
      ],
      listing: {
        overline: "Exclusive car subscriptions at DNA Automotive",
        title: "Your dream car. One monthly rate. Maximum freedom.",
        text: "Experience automotive variety at the highest level. With the exclusive car subscription offers of DNA Automotive GmbH, you enjoy first-class vehicles at attractive monthly conditions. Whether a sporty MINI John Cooper Works, a comfortable Mercedes-Benz saloon, an exclusive BMW or a luxurious Range Rover: discover our immediately available vehicles and find the right car subscription for your individual requirements.",
        text2: "Our offers convince with transparently displayed monthly gross rates and generous free mileage of up to 3,500 kilometres per month. Discover your dream car now, enquire about a subscription and get personal advice.",
        allBrands: "All brands",
        allPrices: "All rates",
        priceLow: "up to €1,000",
        priceMid: "€1,000 – 2,000",
        priceHigh: "over €2,000",
        badge: "Available now",
        badgeSub: "Car subscription possible immediately",
        perMonth: "gross / month",
        freeKm: "free kilometres monthly",
        cta: "Enquire about this subscription",
        count: "vehicles available now",
        empty: "No vehicles for this selection – please adjust the filters.",
        examplePhoto: "Example photo",
      },
      benefitsBar: [
        { t: "€0", d: "Down payment" },
        { t: "6 mo.", d: "Term" },
        { t: "3,500 km", d: "per month incl." },
        { t: "∞", d: "Additional drivers" },
        { t: "All-in", d: "Insurance · Tax · Service" },
      ],
      subscription: {
        tag: "Subscription",
        title: "Drive by subscription",
        desc: "Your desired vehicle on a monthly subscription. Insurance, tax, maintenance and registration included – just get in and drive.",
        features: ["Fixed monthly rate, all included", "Flexible term of your choice", "No down payment required", "Insurance, tax & maintenance included"],
        cta: "Request subscription",
      },
      rental: {
        tag: "Rental",
        title: "Premium rental",
        desc: "Need a vehicle only short-term? Rent exclusive vehicles by the day or week – ideal for special occasions.",
        features: ["Daily, weekly & monthly rental", "Exclusive vehicle selection", "Fair, transparent prices", "Fast & easy handling"],
        cta: "Send rental request",
      },
    },
    finance: {
      overline: "The right financing",
      title: "Financing",
      subtitle: "Your dream car – financed to fit. Fair, transparent and safe, together with our strong partners.",
      benefits: [
        { t: "From 4.90%", d: "Attractive rates for your desired financing." },
        { t: "No down payment", d: "Financing possible even without a down payment." },
        { t: "Up to 120 months", d: "Flexible terms – tailored to your budget." },
        { t: "Fast approval", d: "Straightforward handling right here in-house." },
      ],
      calc: { title: "Financing calculator", amount: "Vehicle price", down: "Down payment", term: "Term", months: "months", monthly: "Approx. monthly rate", rate: "Interest rate", disclaimer: "Non-binding example calculation. Subject to credit approval. Not a binding offer." },
      partnersTitle: "Our financing partners",
      cta: "Request financing",
    },
    ankauf: {
      overline: "Sell your vehicle",
      title: "Sell Your Car",
      subtitle: "Sell your vehicle to DNA Automotive quickly, fairly and hassle-free. Fill in the details, upload photos – we'll get back to you with an offer.",
      steps: [
        { t: "Enter details", d: "Provide vehicle and contact information." },
        { t: "Upload photos", d: "Add photos of your vehicle." },
        { t: "Get an offer", d: "We'll reply with a fair offer." },
      ],
      form: {
        yourData: "Your details", vehicleData: "Vehicle details",
        name: "Name", email: "Email", phone: "Phone",
        brand: "Make", model: "Model", year: "First registration (e.g. 05/2019)",
        mileage: "Mileage", fuel: "Fuel", transmission: "Transmission",
        condition: "Condition", price: "Price expectation (€)", message: "Message (optional)",
        images: "Upload vehicle photos", uploadHint: "JPG/PNG · up to 12 MB per image",
        submit: "Send purchase request", sending: "Sending...",
        success: "Thank you! Your request has been sent.", error: "Sending failed. Please try again.",
        uploading: "Uploading image...",
      },
    },
    inzahlung: {
      overline: "Trade-in",
      title: "Trade-In",
      subtitle: "Trade in your current vehicle and have its value credited directly towards your new dream car – fairly valued and hassle-free.",
      desiredLabel: "Desired vehicle (optional)",
      desiredPlaceholder: "e.g. BMW X5, Porsche Cayenne ...",
      steps: [
        { t: "Enter your car", d: "Provide details of your current vehicle." },
        { t: "Choose your car", d: "Tell us which vehicle you're interested in." },
        { t: "Get your credit", d: "We value fairly and credit it directly." },
      ],
    },
    about: {
      overline: "About us",
      title: "Welcome to DNA Automotive",
      text: "Based right inside the legendary MotorWorld Cologne, DNA Automotive is far more than a car dealership – we are a destination for people who love cars. In one of Europe's most spectacular automotive experience centres, we present exclusive vehicles in a setting that stirs emotions and makes car dreams tangible.",
      text2: "Our passion is your advantage: purchase, sales, trade-in, brokerage, premium service, financing, leasing, car subscription and rental – all from a single source. We advise honestly, act transparently and always meet you at eye level. For your new car – or the exact vehicle you have been dreaming of.",
      quote: "We don't sell cars. We deliver the feeling your next car gives you.",
      founderName: "Tim Tiedemann",
      founderRole: "Managing Director & Founder",
      locationCaption: "Our showroom · MotorWorld Köln-Rheinland",
      stats: [
        { value: "20+", label: "Vehicles in stock" },
        { value: "8", label: "Premium brands" },
        { value: "100%", label: "Inspected quality" },
        { value: "4.90%", label: "Financing from" },
      ],
    },
    fuhrpark: {
      overline: "Current Fleet",
      title: "Our Vehicles",
      subtitle: "Hand-picked premium vehicles. Our stock changes constantly – secure your dream car.",
      all: "View all vehicles",
      empty: "No vehicles available right now. Contact us – we'll find your dream car.",
      sold: "Sold",
      inquire: "Inquire",
      details: "Details",
    },
    specs: { year: "Year", mileage: "Mileage", power: "Power", fuel: "Fuel", transmission: "Transmission", body: "Body" },
    services: {
      overline: "What we do",
      title: "Our Services",
      intro: "More than a dealership. We see ourselves as a long-term partner for exclusive mobility – lasting customer relationships based on trust, quality and personal service.",
      items: [
        { n: "01", t: "Vehicle Purchase", d: "We buy your vehicle at fair conditions – fast, transparent and hassle-free." },
        { n: "02", t: "Vehicle Sales", d: "Exclusive vehicles, inspected and in top condition. For connoisseurs and enthusiasts." },
        { n: "03", t: "Financing", d: "Individual financing from 4.90 % – even without a down payment, with Santander & Bank11." },
        { n: "04", t: "Leasing", d: "Flexible leasing solutions for private and business customers." },
        { n: "05", t: "Car Subscription", d: "Drive without long-term commitment – one price, all included, cancel anytime." },
        { n: "06", t: "Car Rental", d: "Premium rental cars for days or weeks – ideal for events, trips or extended test drives." },
        { n: "07", t: "Trade-in", d: "Trade in your current vehicle and credit it directly towards your new purchase." },
        { n: "08", t: "Vehicle Delivery", d: "We deliver your vehicle personally – nationwide, across Europe on request." },
        { n: "09", t: "Pick-up Service", d: "We collect your vehicle from your address – for purchase, service or trade-in." },
        { n: "10", t: "Registration Service", d: "Plates, registration, transfers – we handle the complete paperwork." },
        { n: "11", t: "Vehicle Detailing", d: "Professional detailing: interior, exterior, polishing, paint sealing, leather care." },
        { n: "12", t: "Vehicle Lettering", d: "Advertising lettering, company logos and individual designs in premium quality." },
        { n: "13", t: "Wrapping", d: "Colour-change, chrome-delete and paint-protection wraps by certified partners." },
        { n: "14", t: "Fleet Service", d: "Complete care for company fleets: procurement, support, returns – all from one source." },
        { n: "15", t: "Individual Sourcing", d: "Your precise dream vehicle – we source it discreetly through our international network." },
      ],
      komplettOverline: "Complete package",
      komplettTitle: "Why DNA Automotive",
      komplettItems: [
        { t: "Individual advice", d: "Every customer is unique – we listen and deliver tailor-made solutions." },
        { t: "Automotive expertise", d: "Years of experience with premium and high-performance vehicles." },
        { t: "Outstanding availability", d: "Short lines, clear communication, reliable feedback – 24/7 on WhatsApp." },
        { t: "Service after the deal", d: "We're here even after purchase – transparent support, honest answers." },
        { t: "Close collaboration", d: "National & international partner network for vehicles rarely publicly available." },
      ],
      exklOverline: "Exclusivity over quantity",
      exklTitle: "Quality as a promise",
      exklText: "Our portfolio consists exclusively of carefully selected premium and high-performance vehicles. Quality, history and value retention are consistently at the centre.",
      exklPillars: [
        { t: "Personal advice", d: "Individual vehicle solutions perfectly tailored to your needs and requirements." },
        { t: "Discretion as standard", d: "Absolute reliability, confidential communication and professional handling." },
        { t: "A strong network", d: "Access to exceptional vehicles that are often not publicly available." },
      ],
    },
    partners: { overline: "Trust & Financing", title: "Our Partners", subtitle: "Strong partners for secure financing and fair conditions." },
    contact: {
      overline: "Talk to us",
      title: "Contact",
      subtitle: "Questions or interested in a vehicle? We look forward to your message.",
      name: "Name", email: "Email", phone: "Phone", subject: "Subject", message: "Message",
      send: "Send message", sending: "Sending...",
      success: "Thank you! Your inquiry has been sent.",
      error: "Sending failed. Please try again.",
      call: "Call", write: "Write email",
      openingLabel: "Opening hours",
      route: "Plan route",
      whatsapp: "Message via WhatsApp",
      web: "Website",
    },
    deal: {
      overline: "Deal of the Day",
      cta: "Discover this vehicle",
      whatsapp: "Inquire via WhatsApp",
      financing: "Financing from",
      perMonth: "/ month",
    },
    locationStrip: {
      overline: "Our location",
      title: "In the heart of MotorWorld Cologne",
      text: "Experience our vehicles in one of Europe's most spectacular automotive locations – surrounded by classic sports cars, modern architecture and true car culture.",
      cta: "Discover our location",
    },
    servicesHome: {
      all: "Discover all 15 services",
      more: "Learn more",
      categories: [
        { n: "01", t: "Sales & Purchase", d: "Vehicle sales, purchase and trade-in at fair, transparent conditions." },
        { n: "02", t: "Financing & Leasing", d: "Individual financing from 4.90 % and flexible leasing solutions with Santander & Bank11." },
        { n: "03", t: "Car Subscription & Rental", d: "Drive flexibly without long-term commitment – car subscription or premium rental." },
        { n: "04", t: "Premium Full Service", d: "Detailing, wrapping, lettering, registration, delivery, fleet and sourcing." },
      ],
    },
    footer: { rights: "All rights reserved.", imprint: "Imprint", privacy: "Privacy", nav: "Navigation", cookies: "Cookie settings" },
    cookie: {
      title: "Cookies & Privacy",
      text: "We use technically necessary cookies to make this website work. With your consent, we also use analytics cookies (PostHog) to understand and improve the use of our website. No tracking takes place without your consent. You can change your choice at any time via the cookie settings in the footer.",
      more: "More in our privacy policy",
      acceptAll: "Accept all",
      essential: "Essential only",
    },
    detail: { back: "Back to fleet", inquire: "Inquire about this vehicle", whatsapp: "Inquire via WhatsApp", description: "Description", price: "Price" },
    admin: {
      login: "Sign in", email: "Email", password: "Password", loggingIn: "Signing in...",
      dashboard: "Vehicle Management", newVehicle: "New Vehicle", edit: "Edit", delete: "Delete",
      save: "Save", cancel: "Cancel", logout: "Logout",
      confirmDelete: "Really delete this vehicle?", uploadImage: "Upload images",
      loginError: "Invalid credentials",
    },
  },
  es: {
    nav: { vehicles: "Vehículos", sold: "Vehículos vendidos", services: "Servicios", service: "Service", about: "Nosotros", contact: "Contacto", career: "Empleo", abo: "Coche por suscripción", rental: "Alquiler de coches", financing: "Financiación", ankauf: "Vender coche", ankaufInzahlung: "Compra / Entrega a cuenta", inzahlung: "Entrega a cuenta", partners: "Socios", admin: "Admin" },
    hero: {
      overline: "Compra · Venta · Entrega a cuenta · Servicio Premium",
      line1: "Vehículos",
      line2: "Exclusivos",
      line3: "en Colonia",
      subtitle: "Encontramos el coche de tus sueños. Vehículos premium, intermediación transparente y un servicio que marca la pauta.",
      cta1: "Encontrar tu coche",
      cta2: "Contáctanos",
    },
    marqueeWord: "TU NUEVO COCHE",
    abo: {
      overline: "Conduce con flexibilidad",
      title: "Coche por suscripción y alquiler",
      subtitle: "Máxima flexibilidad sin compromiso a largo plazo: un precio, todo incluido. Ya sea por un día o varios meses.",
      ctaConsult: "Solicitar asesoría",
      ctaExplore: "Descubrir vehículos",
      glanceTitle: "El coche por suscripción DNA de un vistazo",
      glanceSubtitle: "Todo lo que mueve tu negocio: transparente y flexible.",
      glance: [
        { t: "Ø 10 días hábiles", d: "Entrega rápida" },
        { t: "6 meses", d: "Duración flexible" },
        { t: "Un precio", d: "Todo incluido" },
        { t: "3.500 km", d: "por mes incluidos" },
        { t: "∞ conductores extra", d: "sin coste adicional" },
        { t: "0 € de entrada", d: "protege tu liquidez" },
        { t: "24/7", d: "Contacto personal" },
        { t: "100 % digital", d: "De la solicitud a la devolución" },
      ],
      advantagesTitle: "Tus ventajas con DNA",
      advantages: [
        { t: "Tu vehículo elegido con equipamiento premium", d: "Recibes exactamente el vehículo que eliges: sin sorpresas, siempre con equipamiento de alta calidad." },
        { t: "Costes claros, total seguridad de planificación", d: "Solo la cuota mensual: sin entrada, sin cuota final, sin costes ocultos." },
        { t: "Garantía de movilidad", d: "Ya sea avería, accidente o inactividad: organizamos un reemplazo de inmediato para que sigas móvil." },
      ],
      stepsTitle: "Cómo funciona",
      stepsSubtitle: "Cuatro pasos sencillos hacia tu vehículo deseado.",
      steps: [
        { t: "Definir tu necesidad", d: "Junto con nuestros expertos encontramos el vehículo y la configuración adecuados para ti." },
        { t: "Elegir tu coche y recibir una oferta", d: "Elige entre una amplia gama de marcas premium. Tu oferta se ajusta exactamente a tus necesidades." },
        { t: "Confirmar el contrato", d: "Firma tu contrato cómodamente y totalmente digital, con acompañamiento transparente." },
        { t: "Ponerte en marcha", d: "Acordamos contigo la fecha y el lugar de entrega. En pocos días, en toda Alemania." },
      ],
      brandsTitle: "Marcas premium por suscripción",
      testimonialsTitle: "Clientes DNA satisfechos",
      testimonials: [
        { name: "Matthias S.", text: "Máxima calidad, gestión impecable y servicio de primera. Una fiabilidad difícil de encontrar hoy en día: ¡totalmente recomendable!" },
        { name: "Detlef B.", text: "La gestión y la entrega salieron genial. Personal muy competente y amable. Un vehículo totalmente equipado con una excelente relación calidad-precio." },
        { name: "Oliver B.", text: "Gestión excelente, rápida y profesional. DNA destaca claramente entre los proveedores." },
        { name: "Maxim G.", text: "La mejor empresa para el alquiler de coches a largo plazo. Los coches están muy bien equipados, ¡servicio top, gestión top! Estamos muy satisfechos." },
      ],
      faqTitle: "Preguntas frecuentes",
      faq: [
        { q: "¿Qué ocurre al final de la duración?", a: "Al finalizar, tú eliges: renuevas tu suscripción con un vehículo nuevo, o el contrato termina automáticamente y recogemos el vehículo, sin complicaciones." },
        { q: "¿Puedo suscribir varios vehículos?", a: "Sí, puedes reservar varios vehículos a la vez sin problema: para empleados individuales, equipos completos o como flota flexible." },
        { q: "¿Qué vehículos ofrece DNA?", a: "Desde compactos urbanos hasta berlinas de lujo, ofrecemos vehículos para cada necesidad, con equipamiento premium." },
        { q: "¿Quién es mi persona de contacto?", a: "En DNA tienes un contacto personal fijo que te acompaña desde la entrega hasta la devolución." },
        { q: "¿En qué se diferencia la suscripción del leasing?", a: "Sin entrada, sin cuota final y sin compromisos largos. Una cuota mensual cubre todos los servicios clave: total seguridad de planificación." },
        { q: "¿Qué ocurre en caso de daño o avería?", a: "Puedes contactarnos en cualquier momento. Gracias a nuestra garantía de movilidad proporcionamos un reemplazo lo antes posible para que sigas móvil." },
      ],
      listing: {
        overline: "Suscripciones exclusivas en DNA Automotive",
        title: "Tu coche soñado. Una cuota mensual. Máxima libertad.",
        text: "Vive la variedad automovilística al más alto nivel. Con las exclusivas ofertas de suscripción de DNA Automotive GmbH disfrutas de vehículos de primera clase con condiciones mensuales atractivas. Ya sea un deportivo MINI John Cooper Works, una cómoda berlina Mercedes-Benz, un exclusivo BMW o un lujoso Range Rover: descubre nuestros vehículos disponibles de inmediato y encuentra la suscripción perfecta para ti.",
        text2: "Nuestras ofertas convencen por sus cuotas mensuales brutas transparentes y sus generosos kilómetros gratuitos de hasta 3.500 kilómetros al mes. Descubre ahora tu coche deseado, solicita tu suscripción y déjate asesorar personalmente.",
        allBrands: "Todas las marcas",
        allPrices: "Todas las cuotas",
        priceLow: "hasta 1.000 €",
        priceMid: "1.000 – 2.000 €",
        priceHigh: "más de 2.000 €",
        badge: "Disponible de inmediato",
        badgeSub: "Suscripción posible de inmediato",
        perMonth: "bruto / mes",
        freeKm: "kilómetros gratuitos al mes",
        cta: "Solicitar esta suscripción",
        count: "vehículos disponibles de inmediato",
        empty: "No hay vehículos para esta selección: ajusta los filtros.",
        examplePhoto: "Foto de ejemplo",
      },
      benefitsBar: [
        { t: "0 €", d: "Pago inicial" },
        { t: "6 meses", d: "Duración" },
        { t: "3.500 km", d: "por mes incl." },
        { t: "∞", d: "Conductores extra" },
        { t: "Todo incl.", d: "Seguro · Impuestos · Mantenimiento" },
      ],
      subscription: {
        tag: "Suscripción",
        title: "Conduce por suscripción",
        desc: "Tu vehículo deseado en suscripción mensual. Seguro, impuestos, mantenimiento y matriculación incluidos: solo súbete y conduce.",
        features: ["Cuota mensual fija, todo incluido", "Duración flexible a tu elección", "Sin pago inicial", "Seguro, impuestos y mantenimiento incluidos"],
        cta: "Solicitar suscripción",
      },
      rental: {
        tag: "Alquiler",
        title: "Alquiler premium",
        desc: "¿Necesitas un vehículo solo a corto plazo? Alquila vehículos exclusivos por días o semanas: ideal para ocasiones especiales.",
        features: ["Alquiler por día, semana y mes", "Selección exclusiva de vehículos", "Precios justos y transparentes", "Gestión rápida y sencilla"],
        cta: "Enviar solicitud de alquiler",
      },
    },
    finance: {
      overline: "La financiación adecuada",
      title: "Financiación",
      subtitle: "El coche de tus sueños, financiado a tu medida. Justo, transparente y seguro, junto a nuestros sólidos socios.",
      benefits: [
        { t: "Desde 4,90%", d: "Tipos atractivos para tu financiación deseada." },
        { t: "Sin pago inicial", d: "Financiación posible incluso sin pago inicial." },
        { t: "Hasta 120 meses", d: "Plazos flexibles, adaptados a tu presupuesto." },
        { t: "Aprobación rápida", d: "Gestión sencilla directamente en nuestras instalaciones." },
      ],
      calc: { title: "Calculadora de financiación", amount: "Precio del vehículo", down: "Pago inicial", term: "Plazo", months: "meses", monthly: "Cuota mensual aprox.", rate: "Tipo de interés", disclaimer: "Cálculo de ejemplo sin compromiso. Sujeto a aprobación crediticia. No es una oferta vinculante." },
      partnersTitle: "Nuestros socios de financiación",
      cta: "Solicitar financiación",
    },
    ankauf: {
      overline: "Vende tu vehículo",
      title: "Compra de vehículos",
      subtitle: "Vende tu vehículo a DNA Automotive de forma rápida, justa y sencilla. Completa los datos, sube fotos y te responderemos con una oferta.",
      steps: [
        { t: "Introduce los datos", d: "Datos del vehículo y de contacto." },
        { t: "Sube fotos", d: "Añade fotos de tu vehículo." },
        { t: "Recibe una oferta", d: "Te responderemos con una oferta justa." },
      ],
      form: {
        yourData: "Tus datos", vehicleData: "Datos del vehículo",
        name: "Nombre", email: "Correo", phone: "Teléfono",
        brand: "Marca", model: "Modelo", year: "Primera matriculación (p. ej. 05/2019)",
        mileage: "Kilometraje", fuel: "Combustible", transmission: "Transmisión",
        condition: "Estado", price: "Precio esperado (€)", message: "Mensaje (opcional)",
        images: "Subir fotos del vehículo", uploadHint: "JPG/PNG · hasta 12 MB por imagen",
        submit: "Enviar solicitud", sending: "Enviando...",
        success: "¡Gracias! Tu solicitud ha sido enviada.", error: "Error al enviar. Inténtalo de nuevo.",
        uploading: "Subiendo imagen...",
      },
    },
    inzahlung: {
      overline: "Entrega a cuenta",
      title: "Entrega a cuenta",
      subtitle: "Entrega tu vehículo actual y descuenta su valor directamente en el coche de tus sueños: valoración justa y sin complicaciones.",
      desiredLabel: "Vehículo deseado (opcional)",
      desiredPlaceholder: "p. ej. BMW X5, Porsche Cayenne ...",
      steps: [
        { t: "Indica tu coche", d: "Introduce los datos de tu vehículo actual." },
        { t: "Elige tu coche", d: "Dinos qué vehículo te interesa." },
        { t: "Recibe el descuento", d: "Valoramos con justicia y lo descontamos." },
      ],
    },
    about: {
      overline: "Sobre nosotros",
      title: "Bienvenido a DNA Automotive",
      text: "Ubicados en el legendario MotorWorld Colonia, DNA Automotive es mucho más que un concesionario: somos un punto de encuentro para quienes aman los coches. En uno de los centros de experiencia automovilística más espectaculares de Europa, presentamos vehículos exclusivos en un ambiente que despierta emociones y hace tangibles los sueños sobre ruedas.",
      text2: "Nuestra pasión es tu ventaja: compra, venta, entrega a cuenta, intermediación, servicio premium, financiación, leasing, suscripción y alquiler, todo de una sola mano. Asesoramos con honestidad, actuamos con transparencia y siempre te tratamos de tú a tú. Para tu nuevo coche, o justo el vehículo con el que llevas tiempo soñando.",
      quote: "No vendemos coches. Entregamos la sensación que te da tu próximo coche.",
      founderName: "Tim Tiedemann",
      founderRole: "Director General y Fundador",
      locationCaption: "Nuestro showroom · MotorWorld Köln-Rheinland",
      stats: [
        { value: "20+", label: "Vehículos en stock" },
        { value: "8", label: "Marcas premium" },
        { value: "100%", label: "Calidad revisada" },
        { value: "4,90%", label: "Financiación desde" },
      ],
    },
    fuhrpark: {
      overline: "Flota Actual",
      title: "Nuestros Vehículos",
      subtitle: "Vehículos premium seleccionados a mano. Nuestro stock cambia constantemente – asegura el tuyo.",
      all: "Ver todos los vehículos",
      empty: "No hay vehículos disponibles ahora. Contáctanos – encontraremos tu coche ideal.",
      sold: "Vendido",
      inquire: "Consultar",
      details: "Detalles",
    },
    specs: { year: "Año", mileage: "Kilometraje", power: "Potencia", fuel: "Combustible", transmission: "Transmisión", body: "Carrocería" },
    services: {
      overline: "Qué hacemos",
      title: "Nuestros Servicios",
      intro: "Más que un concesionario. Nos consideramos un socio a largo plazo para la movilidad exclusiva: relaciones duraderas basadas en confianza, calidad y servicio personal.",
      items: [
        { n: "01", t: "Compra de vehículos", d: "Compramos tu vehículo en condiciones justas: rápido, transparente y sencillo." },
        { n: "02", t: "Venta de vehículos", d: "Vehículos exclusivos, revisados y en óptimo estado. Para conocedores y aficionados." },
        { n: "03", t: "Financiación", d: "Financiación individual desde el 4,90 %, incluso sin entrada, con Santander y Bank11." },
        { n: "04", t: "Leasing", d: "Soluciones de leasing flexibles para particulares y empresas." },
        { n: "05", t: "Coche por suscripción", d: "Conduce sin compromiso a largo plazo: un precio, todo incluido, cancelable en cualquier momento." },
        { n: "06", t: "Alquiler de coches", d: "Coches de alquiler premium por días o semanas: ideal para eventos, viajes o pruebas prolongadas." },
        { n: "07", t: "Entrega a cuenta", d: "Entrega tu vehículo actual y descuéntalo directamente en tu nueva compra." },
        { n: "08", t: "Entrega de vehículos", d: "Entregamos tu vehículo personalmente: en toda Alemania y, previa solicitud, en toda Europa." },
        { n: "09", t: "Servicio de recogida", d: "Recogemos tu vehículo en tu domicilio: para compra, servicio o entrega a cuenta." },
        { n: "10", t: "Servicio de matriculación", d: "Matrículas, registros y transferencias: nos encargamos de todo el papeleo." },
        { n: "11", t: "Preparación de vehículos", d: "Detailing profesional: interior, exterior, pulido, sellado de pintura y cuidado del cuero." },
        { n: "12", t: "Rotulación de vehículos", d: "Rotulación publicitaria, logotipos de empresa y diseños individuales en calidad premium." },
        { n: "13", t: "Vinilado", d: "Vinilos de cambio de color, chrome-delete y protección contra gravilla por socios certificados." },
        { n: "14", t: "Servicio de flotas", d: "Gestión completa de flotas de empresa: adquisición, mantenimiento y devolución, todo de un solo proveedor." },
        { n: "15", t: "Búsqueda individual", d: "Tu vehículo deseado con precisión: lo encontramos discretamente a través de nuestra red internacional." },
      ],
      komplettOverline: "Paquete integral",
      komplettTitle: "Por qué DNA Automotive",
      komplettItems: [
        { t: "Asesoramiento individual", d: "Cada cliente es único: escuchamos y ofrecemos soluciones a medida." },
        { t: "Experiencia automovilística", d: "Años de experiencia con vehículos premium y de alto rendimiento." },
        { t: "Excelente disponibilidad", d: "Vías cortas, comunicación clara y respuesta fiable: 24/7 por WhatsApp." },
        { t: "Servicio también después", d: "Estamos ahí incluso tras la compra: atención transparente, respuestas honestas." },
        { t: "Colaboración estrecha", d: "Red nacional e internacional para vehículos rara vez disponibles públicamente." },
      ],
      exklOverline: "Exclusividad en lugar de cantidad",
      exklTitle: "Calidad como promesa",
      exklText: "Nuestra cartera se compone exclusivamente de vehículos premium y de alto rendimiento seleccionados. Calidad, historial y retención de valor son el eje.",
      exklPillars: [
        { t: "Asesoramiento personal", d: "Soluciones individuales adaptadas a tus necesidades y requisitos." },
        { t: "Discreción como estándar", d: "Fiabilidad absoluta, comunicación confidencial y gestión profesional." },
        { t: "Una red sólida", d: "Acceso a vehículos excepcionales que a menudo no están disponibles públicamente." },
      ],
    },
    partners: { overline: "Confianza y Financiación", title: "Nuestros Socios", subtitle: "Socios sólidos para una financiación segura y condiciones justas." },
    contact: {
      overline: "Habla con nosotros",
      title: "Contacto",
      subtitle: "¿Preguntas o interés en un vehículo? Esperamos tu mensaje.",
      name: "Nombre", email: "Correo", phone: "Teléfono", subject: "Asunto", message: "Mensaje",
      send: "Enviar mensaje", sending: "Enviando...",
      success: "¡Gracias! Tu consulta ha sido enviada.",
      error: "Error al enviar. Inténtalo de nuevo.",
      call: "Llamar", write: "Escribir correo",
      openingLabel: "Horario de apertura",
      route: "Planificar ruta",
      whatsapp: "Escribir por WhatsApp",
      web: "Sitio web",
    },
    deal: {
      overline: "Oferta del día",
      cta: "Descubrir este vehículo",
      whatsapp: "Consultar por WhatsApp",
      financing: "Financiación desde",
      perMonth: "/ mes",
    },
    locationStrip: {
      overline: "Nuestra ubicación",
      title: "En el corazón de MotorWorld Colonia",
      text: "Descubre nuestros vehículos en una de las ubicaciones automovilísticas más espectaculares de Europa: rodeado de deportivos clásicos, arquitectura moderna y auténtica cultura del motor.",
      cta: "Descubrir ubicación",
    },
    servicesHome: {
      all: "Descubre los 15 servicios",
      more: "Más información",
      categories: [
        { n: "01", t: "Venta y compra", d: "Venta de vehículos, compra y entrega a cuenta en condiciones justas y transparentes." },
        { n: "02", t: "Financiación y leasing", d: "Financiación individual desde el 4,90 % y soluciones de leasing flexibles con Santander y Bank11." },
        { n: "03", t: "Suscripción y alquiler", d: "Conduce con flexibilidad sin compromiso a largo plazo: suscripción o alquiler premium." },
        { n: "04", t: "Servicio premium integral", d: "Preparación, vinilado, rotulación, matriculación, entrega, flotas y búsqueda individual." },
      ],
    },
    footer: { rights: "Todos los derechos reservados.", imprint: "Aviso legal", privacy: "Privacidad", nav: "Navegación", cookies: "Configuración de cookies" },
    cookie: {
      title: "Cookies y privacidad",
      text: "Utilizamos cookies técnicamente necesarias para que este sitio web funcione. Con tu consentimiento, también utilizamos cookies de estadística (PostHog) para entender y mejorar el uso de nuestro sitio web. Sin tu consentimiento no se realiza ningún seguimiento. Puedes cambiar tu elección en cualquier momento a través de la configuración de cookies en el pie de página.",
      more: "Más en la política de privacidad",
      acceptAll: "Aceptar todas",
      essential: "Solo esenciales",
    },
    detail: { back: "Volver a la flota", inquire: "Consultar este vehículo", whatsapp: "Consultar por WhatsApp", description: "Descripción", price: "Precio" },
    admin: {
      login: "Iniciar sesión", email: "Correo", password: "Contraseña", loggingIn: "Iniciando...",
      dashboard: "Gestión de Vehículos", newVehicle: "Nuevo Vehículo", edit: "Editar", delete: "Eliminar",
      save: "Guardar", cancel: "Cancelar", logout: "Salir",
      confirmDelete: "¿Eliminar este vehículo?", uploadImage: "Subir imágenes",
      loginError: "Credenciales inválidas",
    },
  },
};
